<mat-form-field class="fd-select__container" color="accent" [formGroup]="parentForm">
  <mat-label>{{field?.label}}</mat-label>
  <mat-select [id]="field?.controlName" [formControl]="relatedFormControl" [required]="field?.required" [panelClass]="field?.panelClass || ''" (selectionChange)="onSelectionChange($event)" (openedChange)="onOpenedChange($event)">
    <input #searchInput autocomplete="off" *ngIf="field?.searchable" matInput class="fd-select__search-input" (input)="filter($event)" (keydown)="handleSpace($event)" [placeholder]="field?.searchPlaceholder">
    <mat-option *ngIf="!field.items || field.items.length === 0">Nenhuma opção encontrada</mat-option>
    <mat-option *ngFor="let item of field.items" [value]="item.value">{{item.label}}</mat-option>
  </mat-select>
  @if (hasError) {
    <mat-error *ngFor="let errorMessage of errorMessages">{{errorMessage}}</mat-error>
  }
</mat-form-field>
